/**
 * @file        src/api/activityLog.js
 * @description Activity Log API calls (/api/activity-log) — the console's whole
 *              action history, read from the tenant's `audit_logs`.
 *
 *              Deliberately separate from api/auditLogs' wallet read: that one
 *              is hard-filtered to the `wallet.` family for the Wallet Recharge
 *              Log, and widening it in place would have turned that screen into
 *              a log of everything.
 * @author      Kinetika Labs
 * @created     2026-09-24
 * @changelog
 *   - 2026-09-24 Claude — Initial.
 */
import { get } from './client';

/**
 * params: { actionFamily?, action?, targetType?, targetId?, actorId?, search?,
 *           from?, to?, page, pageSize }.
 * Response: { data: [rows], meta: { page, pageSize, total } }.
 */
export const listActivity = (params) => get('/activity-log', { params });

/** The action families actually present, so the filter offers no dead options. */
export const activityFamilies = () => get('/activity-log/families');
